import { render, staticRenderFns } from "./MoedaForm.vue?vue&type=template&id=2a745de6"
import script from "./MoedaForm.vue?vue&type=script&lang=js"
export * from "./MoedaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports